import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  cotacoes: null,
  viewType: ['PRECO'],
  selectedStatus: null,
  fornecedores: null,
  cotacoesItens: null,
  showEspecificacao: false,
  showEspecificacaoFornecedor: false,
  showPrecoSemIcms: false,
  showPercentualIcms: false,
  showPrecoTarget: false,
  tipoVisualizacao: 'PRODUTO',
  viewOptions: [
    {
      key: 'PRECO',
      description: 'Por preço',
    },
    {
      key: 'FORMA_PAGAMENTO',
      description: 'Por forma de pagamento',
    },
    {
      key: 'FRETE',
      description: 'Por frete',
    },
  ],
  statusOptions: [
    {
      id: 'TODAS',
      description: 'Todas',
      value: null,
    },
    {
      id: 'FAVORITOS',
      description: 'Apenas favoritos',
      value: 'favorito = true',
    },
  ],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
